<div fxLayout="column" fxFlex="grow" class="display-container" fxLayoutAlign="center center center">

    <!-- Modern Centered Header -->
    <div class="form-header" fxLayout="column" fxLayoutAlign="center center" ngStyle.gt-sm="width:65%">
        <div class="header-icon">
            <mat-icon>description</mat-icon>
        </div>
        <h1 class="form-title">{{form?.title}}</h1>
        <div class="title-underline"></div>
    </div>

    <div *ngFor="let section of sections" ngStyle.gt-sm="width:65%">

        <div style="width: 100%;" fxLayout="column" *ngIf="section.displayed" class="sections-display">

            <!--Section Title-->
            <div *ngIf="section.value" class="section-title" style="font-weight: bold; font-size: 16px; margin-bottom: 10px; color: #333; border-bottom: 1px solid #ddd; padding-bottom: 8px;">
                {{section.value}}
            </div>

            <!--Member Display-->

            <div fxLayout="row wrap" fxFlex="grow">
                <div fxLayout="column" *ngFor="let member of section.members" style="margin-top: 10px;"
                     [fxFlex]="member.proportion ? +member.proportion.value : 100"
                     [ngStyle]="{'align-items': member.align.value}">

                    <div fxLayout="row" style="margin-bottom: 15px;">
                        {{member.title}}
                        <label *ngIf="member.mandatory"><b>*</b></label>
                    </div>

                    <!--Image-->
                    <div *ngIf="member.type.type === 'image'">
                        <img style="object-fit: cover; width: 100%;" *ngIf="member.options.length > 0"
                             [src]="member.options[0].value" alt="no image">
                    </div>
                    <!---->

                    <!--Text-->
                    <div *ngIf="member.type.type === 'text'" fxFlex="grow">
                        <mat-form-field appearance="outline" fxFlex="grow">
                            <label>
                                <input [disabled]="fieldHasTag(member)" [(ngModel)]="member.value" style="width: 100%;"
                                       matInput placeholder="Κείμενο"/>
                            </label>
                        </mat-form-field>
                        <label *ngIf="member.mandatory">*</label>
                    </div>
                    <!--                                -->
                    <!-- TextArea-->
                    <div *ngIf="member.type.type === 'textarea'" fxFlex="grow">
                        <mat-form-field appearance="outline" fxFlex="grow">
                            <label>
                                <textarea matInput [(ngModel)]="member.value"></textarea>
                            </label>
                        </mat-form-field>
                        <label *ngIf="member.mandatory">*</label>
                    </div>
                    <!--                                -->
                    <!-- CheckBox-->
                    <div fxLayout="column" fxLayoutGap="10px"
                         *ngIf="member.type.type === 'checkbox'" fxFlex="grow">
                        <mat-checkbox (change)="checkChanged(section, member, option)"
                                      [checked]="option.value === 1"
                                      [disabled]="checkDisabled(member, option)"
                                      *ngFor="let option of member.options">{{option.label}}
<!--                            <label *ngIf="member.mandatory">*</label>-->
                        </mat-checkbox>
                    </div>
                    <!--                                -->
                    <!--Label-->
                    <div *ngIf="member.type.type === 'label'" fxFlex="grow">
                        <quill-editor readOnly="readOnly" [modules]="{ toolbar: false }" [styles]="editorStylePreview"
                                      [(ngModel)]="member.value" (onEditorCreated)="editorCreated($event, member.value)"></quill-editor>
                    </div>
                    <!--                                -->
                    <!--Radio Button-->
                    <div *ngIf="member.type.type === 'radio'" fxFlex="grow">
                        <mat-radio-group [(ngModel)]="member.value" fxLayout="row wrap">
                            <mat-radio-button style="margin: 5px;"
                                              *ngFor="let option of member.options"
                                              [value]="option">{{option.label}}</mat-radio-button>
                        </mat-radio-group>
                    </div>
                    <!--                                -->
                    <!--Toggle-->
                    <div *ngIf="member.type.type === 'toggle'" fxFlex="grow">
                        <mat-slide-toggle color="primary" [(ngModel)]="member.value">ΟΧΙ/ΝΑΙ</mat-slide-toggle>
<!--                        <label *ngIf="member.mandatory">*</label>-->
                    </div>
                    <!--                                -->
                    <!--  Dropdown-->
                    <div *ngIf="member.type.type === 'select'" fxFlex="grow">
                        <mat-form-field appearance="outline" fxFlex="grow">
                            <mat-select [(ngModel)]="member.value">
                                <mat-option *ngFor="let option of member.options"
                                            [value]="option">{{option.label}}</mat-option>
                            </mat-select>
                        </mat-form-field>
<!--                        <label *ngIf="member.mandatory">*</label>-->
                    </div>
                    <!--                                -->
                </div>
            </div>
            <!--        -->
        </div>
    </div>
    <div *ngIf="isLoading">
        <app-loading></app-loading>
    </div>

    <div *ngIf="showUploadField" style="margin-top:20px; padding: 5px;" ngStyle.gt-sm="width:65%;" ngStyle.lt-md="width:100%;"
         fxFlex="grow" fxLayout="row">

        <div fxLayout="column">

            <div fxLayout="row">

                <button mat-raised-button (click)="fileInput.click()" [class.spinner]="isLoading" [disabled]="isLoading">
                    <span>Επιλογή Αρχείων</span>
                    <input [disabled]="isChecked" #fileInput type="file" multiple (change)="onFileInput($event)"
                           accept="image/png, image/jpeg, application/pdf" style="display:none;"/>
                </button>
            </div>

            <div fxLayout="row" *ngIf="isChecked" style="margin-top: 15px;">
                <label style="color: red; font-size: 12px;">Τα δικαιολογητικά έχουν ήδη ελεγχθεί, γι αυτό το λόγο δεν μπορείτε να μεταφορτώσετε άλλα αρχεία</label>
            </div>

            <div fxLayout="row" fxFlex="grow">

                <div fxLayout="column" fxFlex="grow" *ngIf="currentFiles.length > 0">
                    <div fxLayout="row" style="margin: 20px;">Μεταφορτωμένα αρχεία &nbsp;<b>{{currentFiles.length}}</b></div>


                    <div fxLayout="row" *ngFor="let file of currentFiles; let i = index;" style="margin: 10px; padding: 20px;" class="mat-elevation-z2" fxFlex="grow" fxLayoutAlign="start center center">

                        <div fxLayout="column" fxFlex="grow">

                            <div fxLayout="row" fxFlex="grow" fxLayoutAlign="start center center">
                                <span fxFlex="grow">{{ file.originalname | slice:0:25 }}{{file.originalname > 25 ? '...' : ''}}</span>
                                <span><mat-icon (click)="displayAttachment(file)">visibility</mat-icon></span>
                                <!--                                <span *ngIf="!file.status"><mat-icon style="color: red;" (click)="removeFile(i)">delete</mat-icon></span>-->
                                <!--                                <span *ngIf="file.status"><mat-icon style="color: green;">check</mat-icon></span>-->
                            </div>
                            <!--                            <div fxLayout="row">-->
                            <!--                                <mat-progress-bar mode="determinate" [value]="file.progress"></mat-progress-bar>-->
                            <!--                            </div>-->

                        </div>



                    </div>
                </div>

                <div fxLayout="column" fxFlex="grow" *ngIf="files.length > 0">
                    <div fxLayout="row" style="margin: 20px;">Επιλεγμένα αρχεία &nbsp;<b>{{files.length}}</b></div>


                    <div fxLayout="row" *ngFor="let file of files; let i = index;" style="margin: 10px; padding: 20px;" class="mat-elevation-z2" fxFlex="grow" fxLayoutAlign="start center center">

                        <div fxLayout="column" fxFlex="grow">

                            <div fxLayout="row" fxFlex="grow" fxLayoutAlign="start center center">
                                <span fxFlex="grow">{{ file.name | slice:0:25 }}{{file.name > 25 ? '...' : ''}}</span>
                                <span *ngIf="!file.status"><mat-icon style="color: red;" (click)="removeFile(i)">delete</mat-icon></span>
                                <span *ngIf="file.status"><mat-icon style="color: green;">check</mat-icon></span>
                            </div>
                            <div fxLayout="row">
                                <mat-progress-bar mode="determinate" [value]="file.progress"></mat-progress-bar>
                            </div>

                        </div>



                    </div>
                </div>

            </div>

        </div>

    </div>

    <div *ngIf="displayButton()">
    <div *ngIf="mode !== 'display' && !showTwoFactor" fxLayout="row" fxLayoutAlign="center center center">
        <button [disabled]="isFieldDisabled || isLoading" *ngIf="mode === 'false' && !edit" (click)="submitRequest()"
                mat-raised-button color="primary">Υποβολή
        </button>
        <button [disabled]="isFieldDisabled || isLoading" *ngIf="mode === 'true' && update" (click)="submitRequest()"
                mat-raised-button color="primary">Υποβολή
        </button>
        <button [disabled]="isFieldDisabled || isLoading" *ngIf="mode === 'false' && edit" (click)="updateRequest()"
                mat-raised-button color="primary">Ενημέρωση
        </button>
    </div>
    </div>

    <div *ngIf="showTwoFactor" ngStyle.gt-sm="width:65%;" ngStyle.lt-md="width:100%;"
         fxFlex="grow" fxLayout="row"
         style="height: 80px; background-color: whitesmoke; padding: 5px; margin-top: 5px;">
        <div fxLayout="column" fxLayoutGap="5px">

            <div fxFlex="row wrap">
                                 <span style="font-family: 'Century Gothic', sans-serif;">
                      Πληκτρολογήστε τον 6ψήφιο κωδικό που σας έχει αποσταλεί
                    </span>
            </div>


            <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center center">
                <mat-form-field appearance="legacy">
                    <mat-label>Κωδικός 2 βημάτων</mat-label>
                    <input matInput [(ngModel)]="code"/>
                </mat-form-field>
            </div>
            <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center center">

                <button mat-raised-button class="stepperButton" [disabled]="!code || code.length < 6"
                        (click)="validateCode()">Επαλήθευση
                </button>
                <button [disabled]="!code || code.length < 6" (click)="requestCode()" mat-raised-button
                        class="stepperButton">
                    Επαναποστολή κωδικού
                </button>
            </div>
        </div>
    </div>

</div>
